export function isNotNullUndefinedOrEmptyString<T>(
  value: T
): value is NonNullable<T> {
  const isNotNullOrUndefined = value !== null && typeof value !== 'undefined';
  const isNotEmptyString = typeof value === 'string' ? value !== '' : true;

  return isNotNullOrUndefined && isNotEmptyString;
}
